import { useDeepCompareEffect } from 'ahooks';
import { reportPageLog, reportButtonLog, reportSearchLog } from '@intelligence/v3/utils/logReporter';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';

import type { IDetailsPagePointConfig } from '@intelligence/v3/utils/logReporter';

/**
 * 页面打点
 * @param pageId 页面打点配置键
 * @param idConfig 页面打点配置中的id相关配置，比如uidType和uid
 */
export default function usePageLog(pageId?: string, idConfig?: IDetailsPagePointConfig) {
  useDeepCompareEffect(() => {
    if (!pageId) {
      return;
    }

    const logParams = dbiPageLogMes[pageId];

    if (logParams) {
      reportPageLog({ ...logParams, ...idConfig });
    }
  }, [pageId, idConfig]);
}

export { reportPageLog, reportButtonLog, reportSearchLog };
